import { useRouteLoaderData } from "react-router-dom"
import AdminMatchesShow from "../../components/admin/AdminMatchesShow.jsx"
import { GetMatch } from "../../repo/MatchesRepo.js"
import { GetTournament } from "../../repo/TournamentsRepo.js"

export default function MatchShowPage() {
  const { match, tournament } = useRouteLoaderData('admin-match')

  return(
    <section className="m-8">
      {match && tournament && (
        <AdminMatchesShow tournament={tournament} match={match}/>
      )}
    </section>
  )
}

export async function loader({ params, request }) {
  return {
    match: await GetMatch(params.tournamentId, params.id),
    tournament: await GetTournament(params.tournamentId)
  }
}
